/**
 * Enum values are string-numbers because they represent the parsed values from the puzzle xml file
 */
export enum CrosswordDirectionsEnum {
  Left = '1',
  Right = '2',
  Up = '3',
  Down = '4',
}
